"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnStorage = void 0;
const mobx_1 = require("mobx");
const utils_1 = require("./utils");
/** Loads/saves the column state from sessionStorage. */
class ColumnStorage {
    constructor(states) {
        this.states = states;
    }
    loadExpanded(persistCollapse) {
        const key = `expandedColumn_${persistCollapse}`;
        this.expandedIds = (0, utils_1.loadArrayOrUndefined)(key);
        (0, mobx_1.reaction)(() => this.states.expandedColumns.map((cs) => cs.column.id), (columnIds) => sessionStorage.setItem(key, JSON.stringify(columnIds)));
    }
    loadVisible(storageKey) {
        this.visibleIds = (0, utils_1.loadArrayOrUndefined)(storageKey);
        // Unlike the others, where we only store the value on change, we immediately
        // store this value (but I'm not sure why...), hence using `autorun`.
        (0, mobx_1.autorun)(() => {
            const columnIds = this.states.allVisibleColumns.map((cs) => cs.column.id);
            sessionStorage.setItem(storageKey, JSON.stringify(columnIds));
        });
    }
    wasExpanded(id) {
        var _a;
        return (_a = this.expandedIds) === null || _a === void 0 ? void 0 : _a.includes(id);
    }
    wasVisible(id) {
        var _a;
        return (_a = this.visibleIds) === null || _a === void 0 ? void 0 : _a.includes(id);
    }
    done() {
        this.expandedIds = undefined;
    }
}
exports.ColumnStorage = ColumnStorage;
